type IFontProperty = {
  fontSize: string
}

export type ITheme = {
  brand: string
  mq: {
    sm: string
    md: string
    lg: string
    xl: string
  }
  colors: {
    primary: string
    primaryButtonHover: string
    buttonDisabled: string
    secondary: string
    textDarkblack: string
    textLightblack: string
    positive: string
    positive2: string
    positive3: string
    primaryLightText: string
    secondaryLightText: string
    spartaGreen: string
    spartaGreen2: string
    secondaryHeading: string
    borderColor: string
    grey2: string
    linkColor: string
    yield: string
    lightBackground: string
    white: string
    navColor: string
    footerText: string
    alertGreen: string
    alertGreen2: string
    alertGrey: string
    warning2: string
    warning: string
    warningContrast: string
    alertRed: string
    shadowColour: string
    cardHeaderFontColor: string
    danger: string
    boxShadow: string
    bannerSectionContentColor: string
  }
  backgrounds: {
    backGround1: string
    backGround2: string
    backGround3: string
  }
  font: {
    weight: {
      normal: number
      slightBold: number
      semiBold: number
      bold: number
    }
    size: {
      smaller: string
      small: string
      medium: string
      larger: string
      largest: string
    }
    caption: IFontProperty
    primaryButton: IFontProperty
    text: IFontProperty
  }
  other: {
    primaryButton: {
      borderRadius: string
      fontWeight: number
      fontSize: string
    }
  }
}

export interface IVehicleProps {
  kwhper100km: any
  id: string
  year: string
  make: string
  family: string
  vehicleImage: { base64Image: string }
  shadowPR: boolean
  fuelConsumption: number
  fuelType: string
  payLoad: string
  procurementFee: number
  style: string
  vehicleDescription: string
  vehicleType: string
  deliveryFee: number
  luxuryCarTax: number
  basePrice: number
  totalPurchasePrice: number
  dealerDiscount: number
  fuelTankCapacity: number
  roadsideAssistanceTerm: number
}

export interface IAfterMarketAccessoryProps {
  priceIncGST: number
  description: string
}


export interface IAfterMarketAccessoriesProps {
  aftermarketOrderLines: [IAfterMarketAccessoryProps]
}

export enum NextStepValue {
  ATO = 'ato',
  DEFERRED = 'deferred',
  INSURANCE = 'insurance',
  NONE = '',
}

export enum FinAppStatusValue {
  NONE = '',
  NOTSTARTED = 'notstarted',
  STARTED = 'started',
  COMPLETED = 'completed',
}

export enum VideoPlayerStyle {
  EMBEDDED,
  POPUP,
  EXPANDABLE,
}
